<template>
  <div class="action action-txt">
    <div class="action_wrap book-viewer__cats__wrap">
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold">
        Văn bản
      </h2>
      <div class="action__detail">
        <div class="action__upload">
          <a href="javascript:;" class="btn btn-main font-size-16 border-rd-20" @click="addNewTxt()">
            <i class="icon-plus color-light"></i>
            Thêm văn bản
          </a>
        </div>
        <div class="action__section">
          <div class="action__section__list action__section__list--form">
            <div class="item select-custom">
              <select class="primary-color-txt border-rd-20 font-size-15 form-h30 bg-color-light border-0 full-width" @change="handleChangeStyle($event, 'fontFamily')">
                <option v-for="(item, index) of fonts" :key="index" :value="item.value">Font - {{ item.name }}</option>
              </select>
              <i class="icon-arrow-down font-size-13 primary-color"></i>
            </div>
            <div class="action__section__row display-flex-center justify-content-between">
              <div class="item select-custom">
                <select class="primary-color-txt border-rd-20 font-size-15 form-h30 bg-color-light border-0 full-width" v-model="fontSizeDefault" @change="handleChangeStyle($event, 'fontSize')">
                  <option v-for="(item, index) of fontSizes" :key="index" :value="item">{{ item }}pt</option>
                </select>
                <i class="icon-arrow-down font-size-13 primary-color"></i>
              </div>
              <div class="item select-custom">
                <select class="primary-color-txt border-rd-20 font-size-15 form-h30 bg-color-light border-0 full-width" @change="handleChangeFontStyle">
                  <option v-for="(item, index) of fontStyle" :key="index" :value="item.value">{{ item.name }}</option>
                </select>
                <i class="icon-arrow-down font-size-13 primary-color"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="action__section">
          <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Căn lề</label>
          <div class="action__section__list display-flex-wrap">
            <div
              v-for="(item, index) of aligns"
              :key="index"
              class="item bg-color-light primary-color display-flex-center justify-content-center"
              @click="handleChangeStyle(item.value, 'textAlign')"
            >
              <i class="font-size-17" :class="item.icon"></i>
            </div>
          </div>
        </div>
        <div class="action__section">
          <SidebarActionColor @changeColor="changeColor" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarActionColor from './SidebarActionColor.vue'
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, KEY_TXT } from './../../_store/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'

export default {
  name: 'SidebarActionText',
  mixins: [ mixinsDetailLesson ],
  components: {
    SidebarActionColor
  },
  data () {
    return {
      fontActive: 'arial',
      fontSizeDefault: 16,
      fonts: [
        { value: 'arial', name: 'Arial'},
        { value: 'helvetica', name: 'Helvetica'},
        { value: 'pacifico', name: 'Pacifico'},
        { value: 'delicious', name: 'Delicious'},
        { value: 'optima', name: 'Optima'},
        { value: 'courier', name: 'Courier'},
        { value: 'myriad pro', name: 'Myriad Pro'},
        { value: 'verdana', name: 'Verdana'},
        { value: 'georgia', name: 'Georgia'},
        { value: 'comic sans ms', name: 'Comic Sans MS'},
        { value: 'impact', name: 'Impact'},
        { value: 'monaco', name: 'Monaco'},
        { value: 'plaster', name: 'Plaster'},
        { value: 'engagement', name: 'Engagement'},
        { value: 'ubuntu', name: 'Ubuntu'},
        { value: 'patua one', name: 'Patua One'}
      ],
      fontSizes: [10, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 60, 72],
      fontStyle: [
        {value: 'normal', name: 'Regular'},
        {value: 'italic', name: 'Italic'},
        {value: 'underline', name: 'Underline'},
        // {value: 'oblique', name: 'Oblique'}
      ],
      aligns: [
        {value: 'left', icon: 'icon-align-left'},
        {value: 'center', icon: 'icon-align-center'},
        {value: 'justify', icon: 'icon-align-justify'},
        {value: 'right', icon: 'icon-align-right'}
      ],
      slideObj: null
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slideCurr', 'slidesMain', 'slideIndexVisible'])
  },
  mounted () {
    // this.slideObj = this.slideCurr
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetObjActiSlide', 'acSetSlideCurr', 'acSetSlidesMain']),

    handleChangeStyle (evt, key) {
      let value = evt && evt.target ? evt.target.value: evt
      this.changeStyleForArea(key, value)
    },

    changeColor (val) {
      this.changeStyleForArea('fill', val)
      // var object = this.slideCurr.getActiveObject();
      // if (!object) return;
      // // console.log('change style of obj: ', object, object.width)
      // object.set(name, value).setCoords();
      // this.slideCurr.renderAll();
      // this.handleSaveCanvas()

    },

    handleChangeFontStyle (evt) {
      let val = evt.target.value
      let valSetStyle = val === 'underline' ? true : val
      let keySetStyle = val === 'underline' ? 'underline': 'fontStyle'
      this.changeStyleForArea(keySetStyle, valSetStyle)
      val !== 'underline' && this.changeStyleForArea('underline', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>